module.exports = __webpack_public_path__ + "static/media/bg.294c241c.png";